import "./Pictogram.scss"

import { FunctionComponent, ReactNode, SyntheticEvent } from "react"

import Spinner from "components/Spinner/Spinner"
import pictureModals from "stores/pictureModals"
import Badge from "components/Badge/Badge"

export interface IPictogramProps {
    src?: string
    fullSizeSrc?: string
    alt?: string
    size?: string
    theme?: "default" | "lightgrey" | "midgrey" | "grey" | "lightyellow" | "yellow" | "transparent"
    cover?: boolean
    isLoading?: boolean
    imgSize?: string
    badge?: ReactNode
}

const Pictogram: FunctionComponent<IPictogramProps> = ({
    src,
    fullSizeSrc,
    alt = "",
    size = "64px",
    theme = "default",
    cover = false,
    isLoading = false,
    imgSize,
    badge,
}) => {
    function handleClick(event: SyntheticEvent) {
        if (fullSizeSrc) {
            event.stopPropagation()
            pictureModals.show({ pictureSrc: fullSizeSrc })
        }
    }

    return (
        <div
            onClick={handleClick}
            className={`pictogram pictogram--theme-${theme} ${cover ? 'pictogram--cover' : ''} ${!!fullSizeSrc ? 'pictogram--clickable' : ''}`}
            data-testid="pictogram"
            style={{
                width: size,
                height: size
            }}>
            <div className="pictogram__content">
                {isLoading &&
                    <Spinner size={imgSize ? parseInt(imgSize) : 40} />
                }
                {!isLoading && !!src &&
                    <img src={src} alt={alt} className="pictogram__img" style={{ width: imgSize }}
                        data-testid="pictogram-img" />
                }
            </div>
            {!!badge &&
                <div className="pictogram__badge">
                    <Badge theme="red">{badge}</Badge>
                </div>
            }
        </div>
    )
}

export default Pictogram
